import React from "react";
import { Helmet } from "react-helmet-async";
import { siteConfig } from "@/lib/siteConfig";

export default function Seo({
  title,
  description,
  keywords = "",
  path = "/",
  type = "website",
  image,
  jsonLd = [],
}) {
  const canonical = `https://compubrain.com/knowledge/${path}`;
  const ogImage = image || siteConfig.ogImage;
  const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={siteConfig.robots} />
      <meta name="author" content={siteConfig.author} />
      <meta name="contact" content={siteConfig.contact} />
      <meta name="distribution" content={siteConfig.distribution} />
      <meta name="rating" content={siteConfig.rating} />
      <meta name="revisit-after" content={siteConfig.revisitAfter} />
      {siteConfig.geoPlacenames.map((g, i) => (
        <meta name="geo.placename" content={g} key={`geo-${i}`} />
      ))}
      <meta name="geo.region" content={siteConfig.geoRegion} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={siteConfig.siteName} />
      <meta property="og:email" content={siteConfig.email} />
      {siteConfig.phone && <meta property="og:phone_number" content={siteConfig.phone} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={siteConfig.twitterHandle} />
      <meta name="twitter:creator" content={siteConfig.twitterHandle} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <link rel="canonical" href={canonical} />

      {blocks.filter(Boolean).map((b, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(b)}
        </script>
      ))}
    </Helmet>
  );
}
